import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { BenchmarkStore, BenchmarkState } from './benchmark.store';
import { BenchmarkService } from './benchmark.service';
import { distinctUntilChanged, shareReplay, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BenchmarkQuery extends QueryEntity<BenchmarkState> {
    constructor(
        protected store: BenchmarkStore,
        private _benchmarkService: BenchmarkService
    ) {
        super(store);
        this._benchmarkService.getAvailable().pipe(take(1)).subscribe();
    }

    isLoading$ = this.selectLoading();

    selectAvailableBenchmarks$ = this.selectAll().pipe(
        distinctUntilChanged((prev, curr) => {
            if (!prev || !curr) return prev === curr;
            if (prev.length !== curr.length) return false;
            return prev.every((benchmark, index) => benchmark.id === curr[index].id);
        }),
        shareReplay(1)
    );
    selectBenchmark$ = (id: string) => this.selectEntity(id);
}
